"use client";

import { c as _c } from "react/compiler-runtime";
import useToggle from "@/hooks/use-toggle";
import { cn } from "@/lib/utils";
import { EyeIcon, EyeOffIcon } from "lucide-react";
import { useId } from "react";
import InputError from "./input-error";
function BaseInput(t0) {
  const $ = _c(10);
  let className;
  let isError;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      isError,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = isError;
    $[3] = props;
  } else {
    className = $[1];
    isError = $[2];
    props = $[3];
  }
  const t1 = props.id;
  const t2 = isError ? "border-red-600 focus:border-red-400 focus:ring-red-200" : "border-neutral-300 focus:border-neutral-400 focus:ring-neutral-200";
  let t3;
  if ($[4] !== className || $[5] !== t2) {
    t3 = cn("outline-none border h-10 px-3 rounded-md w-full ring-3 ring-transparent transition ", t2, className);
    $[4] = className;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props || $[8] !== t3) {
    t4 = <input id={t1} className={t3} {...props} />;
    $[7] = props;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
function PasswordInput(props) {
  const $ = _c(11);
  const [shown, toggleShown] = useToggle(false);
  const t0 = !shown ? "password" : "text";
  let t1;
  if ($[0] !== props || $[1] !== t0) {
    t1 = <BaseInput {...props} type={t0} id={props.id} className="pr-9" />;
    $[0] = props;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== shown) {
    t2 = !shown ? <EyeOffIcon className="size-4 text-inherit" /> : <EyeIcon className="size-4 text-inherit" />;
    $[3] = shown;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2 || $[6] !== toggleShown) {
    t3 = <button type="button" onClick={toggleShown} className="absolute right-3 cursor-pointer">{t2}</button>;
    $[5] = t2;
    $[6] = toggleShown;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <div className="relative flex items-center">{t1}{t3}</div>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
export default function Input(t0) {
  const $ = _c(22);
  let className;
  let error;
  let label;
  let props;
  if ($[0] !== t0) {
    ({
      label,
      error,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = error;
    $[3] = label;
    $[4] = props;
  } else {
    className = $[1];
    error = $[2];
    label = $[3];
    props = $[4];
  }
  const id = useId();
  const isError = !!error;
  let t1;
  if ($[5] !== className) {
    t1 = cn("grid gap-2", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== id || $[8] !== isError || $[9] !== label) {
    t2 = label && <label htmlFor={id} className={cn("font-semibold", isError && "text-red-600")}>{label}</label>;
    $[7] = id;
    $[8] = isError;
    $[9] = label;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== id || $[12] !== isError || $[13] !== props) {
    t3 = props.type !== "password" ? <BaseInput {...props} isError={isError} id={id} /> : <PasswordInput {...props} isError={isError} id={id} />;
    $[11] = id;
    $[12] = isError;
    $[13] = props;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== error) {
    t4 = <InputError error={error} />;
    $[15] = error;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== t1 || $[18] !== t2 || $[19] !== t3 || $[20] !== t4) {
    t5 = <div className={t1}>{t2}{t3}{t4}</div>;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  return t5;
}